import './offers-filter.scss';

import { leaseOptions } from '../../core/selectors/leaseFilter';
import { selectLeaseFilter } from '../../core/actions/leaseFilter';
riot.tag2('offers-filter', '<label class="offers-filter-label">{getLabel(\'labels.filters.leaseFilterLabel\')}</label> <div class="offers-filter-dropdown"> <select class="offers-filter-select" name="leaseFilter" id="leaseFilter" onchange="{selectFilterHandler}"> <option each="{option, i in leaseOptions}" riot-value="{i}">{option.filtertitle}</option> </select> <i class="offers-filter-select-icon"></i> </div>', '', 'if="{leaseOptions.length}"', function(opts) {

    const self = this;

    this.mixin('redux');
    this.mixin('bus');
    this.subscribe(leaseOptions);

    this.dispatchify({ selectLeaseFilter });

    function selectFilterHandler() {
      const filterValue = self.leaseFilter.value;

      self.selectLeaseFilter({ filter: filterValue });

      self.bus.trigger(self.bus.EVENTS.LEASE.LEASE_PAYMENT_CHANGE, { newValue: filterValue });
    }

    this.selectFilterHandler = selectFilterHandler;
});
